import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaList } from 'react-icons/fa';

const NavBar = ({ auth, onLogout }) => {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    // Close mobile menu when navigating
    useEffect(() => {
        setOpen(false);
    }, [location]);

    // Debug auth state
    useEffect(() => {
    }, [auth]);

    return ( 
        <div className='shadow-md w-full fixed top-0 left-0 z-50'>
            <div className='md:flex items-center justify-between bg-white py-4 md:px-10 px-7'>
                <div className='font-bold text-2xl cursor-pointer flex items-center text-gray-800'>
                    <Link to='/'>
                        <span className='text-3xl font-bold'>
                            <span className='text-green-600'>Street Horticulture</span>{' '}
                            Inventory System
                        </span>
                    </Link>
                </div>
                
                {/* Mobile menu button */}
                <div 
                    onClick={() => setOpen(!open)} 
                    className='text-3xl absolute right-8 top-6 cursor-pointer md:hidden'
                >
                    <FaList name={open ? 'close' : 'menu'} />  
                </div>
                
                {/* Navigation links */}
                <ul className={`md:flex md:items-center md:pb-0 pb-12 absolute md:static bg-white md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${open ? 'top-20 opacity-100' : 'top-[-500px]'} md:opacity-100 opacity-0`}>
                    <li className='md:ml-8 text-xl md:my-0 my-7'>
                        <Link to='/' className='hover:text-green-600 transition'>Home</Link>
                    </li>

                    {/* Inventory link - only shown to admin */}
                    {auth?.isLoggedIn && auth?.role === "admin" && (
                    <li className='md:ml-8 text-xl md:my-0 my-7'>
                        <Link to='/admin' className='hover:text-green-600 transition'>Inventory</Link>
                    </li>
                    )}

                    {/* About link (example additional link) */}
                    {/* <li className='md:ml-8 text-xl md:my-0 my-7'>
                        <Link to='/about' className='hover:text-green-600 transition'>About</Link>
                    </li> */}

                    {/* Login/Logout button */}
                    <li className='md:ml-8 text-xl md:my-0 my-7'>
                        {auth?.isLoggedIn ? (
                            <button 
                                onClick={onLogout}
                                className='bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded transition'
                            >
                                Logout
                            </button>
                        ) : (
                            <Link 
                                to='/login' 
                                className='bg-green-500 hover:bg-green-600 text-white px-4 py-1 rounded transition'
                            >
                                Login
                            </Link>
                        )}
                    </li>
                </ul>
            </div>
        </div>
    );
}
 
export default NavBar;